﻿export class ProposedAnswerSearchModel {
    questionID: number;
    languageId: number;

}